export const MusicSelectionModal = () => `
        <div id="music-selection-modal" class="settings-modal hidden">
            <div class="settings-content glass-panel music-modal-content">
                <div class="settings-header">
                    <h3><span class="icon">🎵</span> MÜZİK & SES</h3>
                    <button id="close-music-btn" class="close-btn" title="Kapat">✖</button>
                </div>

                <div class="settings-body music-modal-body">
                    <!-- PLAYER CONTROLS & VOLUME -->
                    <div class="setting-group player-controls-group player-controls-card">
                        <div id="music-current-track" class="current-track-title">Parça Seçilmedi</div>
                        
                        <div class="progress-slider-container">
                            <span id="music-current-time" class="time-label current-time">0:00</span>
                            <input type="range" id="music-progress-slider" class="volume-slider music-progress-bar" min="0" max="100" value="0">
                            <span id="music-total-time" class="time-label total-time">0:00</span>
                        </div>

                        <div class="player-buttons-row">
                            <button id="music-shuffle-btn" class="icon-toggle-btn shuffle-btn" title="Karışık Çal">
                                <span class="icon">🔀</span>
                            </button>
                            <button id="music-play-pause-btn" class="icon-toggle-btn play-pause-btn" title="Oynat/Duraklat">
                                <span class="icon" id="music-play-icon">⏸</span>
                            </button>
                            <button id="music-next-btn" class="icon-toggle-btn next-btn" title="Sıradaki Parça">
                                <span class="icon">⏭</span>
                            </button>
                        </div>
                        
                        <!-- Divider -->
                        <div class="card-divider"></div>

                        <!-- Volume Control -->
                        <div class="volume-control-row">
                            <button id="music-mute-btn" class="icon-toggle-btn mute-toggle-btn" title="Sesi Kapat/Aç">
                                <span class="icon" id="music-mute-icon">🔊</span>
                            </button>
                            <input type="range" id="music-modal-volume-slider" class="volume-slider music-volume-bar" min="0" max="1" step="0.1" value="0.5">
                        </div>
                    </div>

                    <div class="setting-group select-music-group">
                        <label class="group-label">OYUN MÜZİĞİ SEÇİN</label>

                        <!-- TABS -->
                        <div class="music-tabs">
                            <button class="music-tab-btn tab-btn active" data-category="general">GENEL MÜZİKLER</button>
                            <button class="music-tab-btn tab-btn" data-category="sultan">PADİŞAH BESTELERİ</button>
                        </div>

                        <div id="music-cards-container" class="music-cards-grid">
                            <!-- Populated by JS -->
                        </div>
                    </div>
                </div>

                <div class="settings-footer music-modal-footer">
                    <button id="music-ok-btn" class="gaddar-btn primary music-ok-btn">TAMAM</button>
                </div>
            </div>
        </div>
`;
